import { getAsyncTypes } from '../helpers/actionType'
import log from '../helpers/logger';
import { RememberCurrent, GetCurrent } from './Persist';
const SCREEN_PREFIX = 'Onboarding';
const PERSIST_KEY = SCREEN_PREFIX + "_LAST_ONBOARDING"
export const SUBMIT_ONBOARDING = getAsyncTypes(SCREEN_PREFIX, 'SUBMIT_ONBOARDING');
export const REMEMBER_ONBOARDING = getAsyncTypes(SCREEN_PREFIX, 'REMEMBER_ONBOARDING');
export const LOAD_ONBOARDING = getAsyncTypes(SCREEN_PREFIX, 'LOAD_ONBOARDING');
export const LOAD_PAGE = getAsyncTypes(SCREEN_PREFIX, 'LOAD_PAGE');
export const FLUSH_ONBOARDING = getAsyncTypes(SCREEN_PREFIX, 'FLUSH_ONBOARDING');
export const RESET = getAsyncTypes(SCREEN_PREFIX, "RESET");

const initState = {
  currentOnboarding: {
  }
}

// reducer
export function onboardingReducer(state = initState, action) {
  const payload = action.payload;
  switch (action.type) {
    case RESET.SUCCEEDED:
      return initState
    case FLUSH_ONBOARDING.SUCCEEDED:
      return initState
    case LOAD_PAGE.STARTED:
      return {
        loading: true,
      }
    case LOAD_PAGE.SUCCEEDED:
      return {
        // ...(payload.Ddl || {}),
        currentOnboarding: {
          ...payload.currentOnboarding
        },
        initialized: true,
        loading: false,
        key: Date.now(),
      }
    case SUBMIT_ONBOARDING.STARTED:
      return {
        ...state,
        loading: true,
        // do not change version on async start
      }
    case SUBMIT_ONBOARDING.FAILED:
      return {
        ...state,
        loading: false,
        key: Date.now() // always revise verioning failed or succeeded.
      }
    case SUBMIT_ONBOARDING.SUCCEEDED:
      return {
        ...state,
        currentOnboarding: {
          ...state.currentOnboarding,
          ...payload,
          result: "success",

        },
        loading: false,
        key: Date.now()
      }
    case REMEMBER_ONBOARDING.SUCCEEDED:
      return {
        ...state,
        currentOnboarding: {
          ...state.currentOnboarding,
          ...payload,
        },
        loading: false,
      }
    default:
      return state;
  }
}

// action
export function resetOnboarding() {
  return { type: RESET.SUCCEEDED, payload: {} }
}

export function saveOnboarding(currentOnboarding) {
  const savedOnboarding = { ...currentOnboarding }
  // RememberCurrent(PERSIST_KEY, savedOnboarding);
  return { type: SUBMIT_ONBOARDING.SUCCEEDED, payload: savedOnboarding }
}

export function loadPage() {
  return (dispatch, getState, { webApi }) => {
    const lastOnboarding = 
    // GetCurrent(PERSIST_KEY) 
    // || 
    { ...initState.currentOnboarding };
    log.debug(lastOnboarding);
    dispatch({ type: LOAD_PAGE.STARTED, payload: {} })
    // dispatch({ type: LOAD_PAGE.SUCCEEDED, payload: { currentOnboarding: initState.currentOnboarding } })
    dispatch({ type: LOAD_PAGE.SUCCEEDED, payload: { currentOnboarding: lastOnboarding } })
    // quoteService.loandInitPage()
    //     .then(
    //         data => {
    //             dispatch({ type: LOADPAGE.SUCCEEDED, payload: { ...data.data, currentOnboarding:lastOnboarding} })
    //         },
    //         error => {
    //             dispatchWithNotification(dispatch, { type: SUBMITQUOTE.FAILED, payload: error });
    //         }
    //     )
  }
}

export function submitOnboarding(answers) {
  // let curr = GetCurrent(PERSIST_KEY) || initState.currentOnboarding;

  return (dispatch, getState, { webApi }) => {
    dispatch({ type: SUBMIT_ONBOARDING.STARTED, payload: {} })
    dispatch({ type: SUBMIT_ONBOARDING.SUCCEEDED, payload: { ...answers } });
    saveOnboarding(answers);

    return Promise.resolve('success');
    
    // quoteService.getOnboarding(amountPicked)
    //     .then(
    //         data => {
    //             dispatch({ type: SUBMITOnboarding.SUCCEEDED, payload: { ...Onboarding, ...data.data} })
    //         },
    //         error => {
    //             dispatchWithNotification(dispatch, { type: SUBMITOnboarding.FAILED, payload: error });
    //         }
    //     )
  }
}


// WEBPACK FOOTER //
// ./src/redux/Onboarding.js